import React, {Fragment} from "react";
import {Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import ModalConfirm from "../../../components/ModalConfirm";
import NsField from "../../../components/fields/NsField";

export default function FormModificaMacrocategoriaView({
                                                           id,
                                                           show,
                                                           closeModal,
                                                           modalMsg,
                                                           showConfirm,
                                                           formikRef,
                                                           translate,
                                                           SignupSchema,
                                                           addFiglio,
                                                           optionsClassi,
                                                           principale,
                                                           optionsPadri,
                                                           macr,
                                                           handleCloseConfirmModifica,
                                                           handleOkConfirmModifica,
                                                           initialValuesForm,
                                                           onSubmitForm,
                                                           onChangeMacrocategoria,
                                                           onChangeMacrocategoriaMadre,
                                                       }) {

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirm}
                handleClose={handleCloseConfirmModifica}
                handleOk={handleOkConfirmModifica}
                testo={translate("Sicuro di voler modificare la macrocategoria madre? Questa modifica porterà ad una variazione della gerarchia delle macrocategorie")}/>
            <Formik
                initialValues={initialValuesForm}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={onSubmitForm}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <NsField
                                name={"id_classe_macrocategoria"}
                                label={"Classe Macrocategoria*:"}
                                as={"select"}
                                isDisabled={id && id !== '' && !addFiglio}
                                options={(optionsClassi ? optionsClassi.map(o => {
                                    return {
                                        label: o.descrizione,
                                        value: o.id_classe_macrocategoria,
                                    };
                                }) : [])}
                                onChange={onChangeMacrocategoria}
                                placeholder={translate("Seleziona una classe")}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                        {
                            principale !== true &&
                            <div className="col-md-12">
                                <NsField
                                    name={"id_kpi_macrocategoria_madre"}
                                    label={"Macrocategoria:"}
                                    as={"select"}
                                    isDisabled={!values['id_classe_macrocategoria']}
                                    options={(optionsPadri ? optionsPadri.map(o => {
                                        return {
                                            label: o.codice + ' - ' + o.descrizione,
                                            value: o.id_kpi_macrocategoria,
                                        };
                                    }) : [])}
                                    onChange={onChangeMacrocategoriaMadre}
                                    placeholder={translate("Seleziona una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                        }
                        <div className="col-md-6">
                            <NsField
                                name={"codice"}
                                label={"Codice:"}
                                isDisabled={macr && macr.id_kpi_macrocategoria}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                        <div className="col-md-6">
                            <NsField
                                name={"descrizione"}
                                label={"Descrizione*:"}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                        <div className="col-md-6">
                            <NsField
                                name={"ordine"}
                                label={"Ordine:"}
                                as={"number"}
                                formikRef={formikRef}
                                values={values}
                                errors={errors}
                                touched={touched}
                                submitCount={submitCount}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
}